export default (el, property, pseudo = 'before') => {
	let value = getComputedStyle(el, `:${pseudo}`).getPropertyValue(property);
	if (property === 'content') value = value.replace(/['"]+/g, '');
	return value;
};
